export const UNPUBLISHED = 'UNPUBLISHED';
export const PUBLISHED_WITH_CHANGES = 'PUBLISHED_WITH_CHANGES';
export const DELETED = 'DELETED';
export const PUBLISHED = 'PUBLISHED';